import React from 'react';
import { Provider } from 'react-redux';
import { browserHistory, Route, Router } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';
import { isEmpty } from 'lodash';
import { persistor, store } from './redux/store';
import { getUser, userLogout } from './common/globals';
import { notifySet, userSet, menuSet } from './redux/actions';
import App from './App';
import NotFound from './pages/NotFound';
import ManageCases from './pages/ManageCase/ManageCases';
import ChangePassword from './pages/ChangePassword';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import EditManageCase from './pages/ManageCase/EditManageCase';
import ManageCaseDetails from './pages/ManageCase/ManageCaseDetails';
import Office from './pages/Office';
import BillingDetail from './pages/ManageCase/BillingDetail';
import Teams from './pages/Teams';
import BillingHome from './pages/Billing/BillingHome';
import Reports from './pages/Reports/Reports';
import Inventory from './pages/Inventory/Inventory';
import Preferences from './pages/Preferences/Preferences';
import ExpressCareSets from './pages/ManageCase/ExpressCareSets';
import Sets from './pages/ManageCase/Sets';
import SetsPreferences from './pages/ManageCase/SetsPreferences';
import Xray from './pages/Xray/Xray';
import Products from './pages/Products/Products';
import AcmProducts from './pages/Products/AcmProducts';
import ProductList from './pages/Products/ProductList';
import Dgr from './pages/Products/Dgr';
import SetsContents from './pages/Inventory/SetsContents';
import MissingDgr from './pages/Billing/MissingDgr';
import MissingDgrFilter from './pages/Billing/MissingDgrFilter';
import SearchBilled from './pages/Billing/SearchBilled';
import ManageCaseFilter from './pages/FilterCase/ManageCaseFilter';
import NotBilled from './pages/Billing/NotBilled';
import AcmSelect from './pages/Products/AcmSelect';
import FilterCases from './pages/ManageCase/FilterCases';
import AddPreference from './pages/Preferences/AddPreference';
import AddPreferenceSets from './pages/Preferences/AddPreferenceSets';
import OfficeSets from './pages/Inventory/OfficeSets';
import Backorders from './pages/Inventory/Backorders';
import ExpressCareSetsInfo from './pages/Inventory/ExpressCareSetsInfo';
import AddEditProduct from './pages/ManageCase/AddEditProduct';
import ProductScan from './pages/ManageCase/ProductScan';
import NoBilledFilter from './pages/Billing/NoBilledFilter';
import SyncData from './pages/SyncData';
import MissingPos from './pages/Billing/MissingPos';
import MissingPosFilter from './pages/Billing/MissingPosFilter';
import XrayUpload from './pages/Xray/XrayUpload';
import Notes from './pages/Products/Notes';
import OtherCharge from './pages/Products/OtherCharge';
import CalendarFeed from './pages/CalendarFeed';
import Billed from './pages/Billing/Billed';
import BilledFilter from './pages/Billing/BilledFilter';
import ExpressSetsContents from './pages/Inventory/ExpressSetsContents';
import AcmFlagDetails from './pages/Products/AcmFlagDetails';
import Bugsnag from './helpers/bugsnag';
import DayFilterCase from './pages/ManageCase/DayFilterCase';
import Consignment from './pages/Inventory/Consignment';
import ViewInventory from './pages/Inventory/ViewInventory';
import ManageSessions from './pages/Inventory/ManageSessions';
import ScanSession from './pages/Inventory/ScanSession';
import ScanInventory from './pages/Inventory/ScanInventory';
import EditSession from './pages/Inventory/EditSession';
import ScanViewInventory from './pages/Inventory/ScanViewInventory';
import SessionList from './pages/Inventory/SessionList';
import SessionFilter from './pages/Inventory/SessionFilter';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Ders from './pages/DERs/Ders';
import AddNonCaseDers from './pages/DERs/AddNonCaseDer';
import SearchDers from './pages/DERs/SearchDers';
import SearchResults from './pages/DERs/SearchResults';
import AggregatePlan from './pages/ManageCase/AggregatePlan';
import Shipments from './pages/Inventory/Shipments.js';
import ShipmentInfo from './pages/Inventory/ShipmentInfo.js';
import SalesMetrics from './pages/SalesMetrics/SalesMetrics.js';
import SalesFilter from './pages/SalesMetrics/SalesFilter.js';
import MoveSets from './pages/Inventory/MoveSets/MoveSets.js';
import MoveToLocation from './pages/Inventory/MoveSets/MoveToLocation.js';
import SDKProvider from './components/commonComponents/Scanner/components/sdk';
import CaseHistory from './pages/ManageCase/CaseHistory';
// import AutoLogin from './pages/AutoLogin';

import SurgeonNotes from './pages/SurgeonNote/SurgeonNotes';
import AddSurgeonNote from './pages/SurgeonNote/AddSurgeonNote';

class Routes extends React.Component {
  _requireAuth = (menu) => async (nextState, replace) => {
    const user = await getUser();
    const currentDateTimeStamp = new Date().getTime();

    if (isEmpty(user) || user.id === null || user.sessionToken === null) {
      store.dispatch(notifySet({ type: 'error', message: 'Login required' }));
      browserHistory.push('/');
      replace(nextState.location);
    } else if (currentDateTimeStamp < Number(user.tokenExpirationDate)) {
      // if (user.office === null) {
      // browserHistory.push('/');
      //  } else {
      if (user.office !== null) {
        menu.length > 0 && store.dispatch(menuSet(menu));
      }
    } else {
      userLogout(true);
    }
  };

  _checkAuth = async () => {
    try {
      const user = await getUser();
      if (isEmpty(user) || user.id === null || user.sessionToken === null) return;
      const currentDateTimeStamp = new Date();
      const tokenExpirationDate = new Date(Number(user.tokenExpirationDate));
      if (currentDateTimeStamp > tokenExpirationDate) {
        if (user) return;
        browserHistory.push('/');
        userLogout(true);
        return;
      }
      if (user.team === null) {
        browserHistory.push('/office');
        return;
      }
      browserHistory.push('/manage-cases');
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  async UNSAFE_componentWillMount() {
    store.dispatch(userSet(await getUser()));
  }

  render() {
    return (
      <SDKProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Router history={browserHistory}>
              <Route component={App}>
                <Route exact path="/" components={{ component: Login }} onEnter={this._checkAuth} />
                <Route path="/change-password" components={{ component: ChangePassword }} onEnter={this._checkAuth} />
                <Route path="/forgot-password" components={{ component: ForgotPassword }} onEnter={this._checkAuth} />

                {/* Manage Cases */}
                <Route path="/manage-cases" components={{ component: ManageCases }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/add-case" components={{ component: EditManageCase }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/edit" components={{ component: EditManageCase }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:caseId" components={{ component: ManageCaseDetails }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/sets" components={{ component: Sets }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/sets/:setName/set-contents" components={{ component: Sets }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/sets/:setName/set-status" components={{ component: Sets }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/sets/express-care-sets" components={{ component: ExpressCareSets }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/sets/preferences" components={{ component: SetsPreferences }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/x-ray" components={{ component: Xray }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/x-ray/upload" components={{ component: XrayUpload }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/products" components={{ component: Products }} onEnter={this._requireAuth([0])} />
                <Route path="/manage-case/:id/products/list" components={{ component: ProductList }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/products/dgr" components={{ component: Dgr }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/acm-products" components={{ component: AcmProducts }} onEnter={this._requireAuth([0])} />
                <Route path="/manage-case/:id/case-history" components={{ component: CaseHistory }} onEnter={this._requireAuth([0])} />
                <Route path="/manage-cases/filter" components={{ component: ManageCaseFilter }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-cases/filter-cases" components={{ component: FilterCases }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/acm-products/select" components={{ component: AcmSelect }} onEnter={this._requireAuth([0])} />
                <Route path="/manage-case/:id/products/add" components={{ component: AddEditProduct }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/products/add/notes" components={{ component: Notes }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/products/add/other-charge" components={{ component: OtherCharge }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/products/scan" components={{ component: ProductScan }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/aggregate-plan/:id" components={{ component: AggregatePlan }} onEnter={this._requireAuth([1])} />
                <Route path="/manage-case/:id/acm-products/acmFlagDetails" components={{ component: AcmFlagDetails }} onEnter={this._requireAuth([0])} />

                <Route path="/billing-detail/:caseId" components={{ component: BillingDetail }} onEnter={this._requireAuth([1])} />
                <Route path="/office" components={{ component: Office }} onEnter={this._requireAuth([0])} />
                <Route path="/billing" components={{ component: BillingHome }} onEnter={this._requireAuth([2])} />
                <Route path="/team" components={{ component: Teams }} onEnter={this._requireAuth([0])} />
                <Route path="/reports" components={{ component: Reports }} onEnter={this._requireAuth([3])} />

                {/* Inventory */}
                <Route path="/inventory" components={{ component: Inventory }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/officeSets" components={{ component: OfficeSets }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/:id/officeSets" components={{ component: SetsContents }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/:id/expressCareSets" components={{ component: ExpressSetsContents }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/expressCareSets" components={{ component: ExpressCareSetsInfo }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment" components={{ component: Consignment }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/view-inventory" components={{ component: ViewInventory }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/view-inventory/session-filter" components={{ component: SessionFilter }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/scan-session" components={{ component: ScanSession }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/scan-session/session-list" components={{ component: SessionList }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/scan-session/scan-inventory" components={{ component: ScanInventory }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/scan-session/edit-session" components={{ component: EditSession }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/scan-session/scan-view-inventory" components={{ component: ScanViewInventory }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/consignment/manage-sessions" components={{ component: ManageSessions }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/backorders" components={{ component: Backorders }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/shipments" components={{ component: Shipments }} onEnter={this._requireAuth([4])} />
                <Route path="/inventory/shipments/:id" components={{ component: ShipmentInfo }} onEnter={this._requireAuth([4])} />

                <Route path="/acm-products/products/notes" components={{ component: Notes }} onEnter={this._requireAuth([1])} />
                <Route path="/missing-dgr" components={{ component: MissingDgr }} onEnter={this._requireAuth([2])} />
                <Route path="/missing-pos" components={{ component: MissingPos }} onEnter={this._requireAuth([2])} />
                <Route path="/missing-pos-filter" components={{ component: MissingPosFilter }} onEnter={this._requireAuth([2])} />
                <Route path="/missing-dgr-filter" components={{ component: MissingDgrFilter }} onEnter={this._requireAuth([2])} />
                <Route path="/search-billed" components={{ component: SearchBilled }} onEnter={this._requireAuth([2])} />
                <Route path="/billing/notBilledCases" components={{ component: NotBilled }} onEnter={this._requireAuth([2])} />
                <Route path="/billing/notBilledCases-filter" components={{ component: NoBilledFilter }} onEnter={this._requireAuth([2])} />

                {/* Preferences */}
                <Route path="/preferences" components={{ component: Preferences }} onEnter={this._requireAuth([5])} />
                <Route path="/preferences/new" components={{ component: AddPreference }} onEnter={this._requireAuth([5])} />
                <Route path="/preferences/:id" components={{ component: AddPreference }} onEnter={this._requireAuth([5])} />
                <Route path="/preferences/new/sets" components={{ component: AddPreferenceSets }} onEnter={this._requireAuth([5])} />
                <Route path="/preferences/:id/sets" components={{ component: AddPreferenceSets }} onEnter={this._requireAuth([5])} />

                <Route path="/sync-data" components={{ component: SyncData }} onEnter={this._requireAuth([6])} />
                <Route path="/calendar-feed" components={{ component: CalendarFeed }} onEnter={this._requireAuth([7])} />
                <Route path="/billed" components={{ component: Billed }} onEnter={this._requireAuth([2])} />
                <Route path="/billed-filter" components={{ component: BilledFilter }} onEnter={this._requireAuth([2])} />
                <Route path="/manage-cases/day-filter" components={{ component: DayFilterCase }} onEnter={this._requireAuth([1])} />
                <Route path="/settings" components={{ component: Settings }} onEnter={this._requireAuth([8])} />
                <Route path="/notifications" components={{ component: Notifications }} onEnter={this._requireAuth([10])} />
                <Route path="/sales-metrics" components={{ component: SalesMetrics }} onEnter={this._requireAuth([11])} />
                <Route path="/sales-filter" components={{ component: SalesFilter }} onEnter={this._requireAuth([11])} />

                {/* <Route path="/ders/add-non-case-der"
                components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} /> */}
                {/* <Route path="/ders/add-case-der/:caseId"
                components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} /> */}
                {/* <Route path="/ders/add-case-der/:derNo"
                components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} /> */}

                <Route path="/ders" components={{ component: Ders }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/add-der" components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/der/:caseId" components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/der/:derNo" components={{ component: AddNonCaseDers }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/search-ders" components={{ component: SearchDers }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/search-ders/search-results" components={{ component: SearchResults }} onEnter={this._requireAuth([9])} />
                <Route path="/ders/search-ders/search-results/:caseId" components={{ component: SearchResults }} onEnter={this._requireAuth([9])} />
                <Route path="/move-sets" components={{ component: MoveSets }} onEnter={this._requireAuth([0])} />
                <Route path="/move-sets-to-location" components={{ component: MoveToLocation }} onEnter={this._requireAuth([0])} />

                {/* Surgeon Notes */}
                <Route path="/surgeon-notes" components={{ component: SurgeonNotes }} onEnter={this._requireAuth([12])} />
                <Route path="/surgeon-notes/add" components={{ component: AddSurgeonNote }} onEnter={this._requireAuth([12])} />
                <Route path="/surgeon-notes/:id/edit" components={{ component: AddSurgeonNote }} onEnter={this._requireAuth([12])} />

                <Route path="*" components={{ component: NotFound }} />

              </Route>
            </Router>
          </PersistGate>
        </Provider>
      </SDKProvider>
    );
  }
}

export default Routes;
